let defaultMessageTime = 5

let initialState = {
  type: "",
  message: null,
  time: defaultMessageTime
}

export const messageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setMessage":
      return { ...state, message: action.payload.message, type: action.payload.type, time: action.payload?.time ?? defaultMessageTime};
    case "removeMessage":
        return { ...state, type: "", message: null, time: defaultMessageTime };
    default:
      return state;
  }
};

export const setMessage = (payload) => ({
    type: "setMessage",
    payload,
});
export const removeMessage = (payload) => ({
    type: "removeMessage",
    payload,
});
